import React, { Component } from 'react';
import { browserHistory, Link, hashHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import utils from '../../utils/config.js'
import {getRandomLoading, getRandomGearsLoading} from '../../utils/loading/loadingUtils.js';
import Icon from '../../images/trickstrat/ts_icon.png';
class LoadingText extends Component {

    render() {
        var {map} = this.props;
        var img =  <span><img width="75"  src={Icon}></img></span>
        var loadingText = "Loading...";
        if (map.game == "TRICKSTRAT") {
         loadingText = getRandomLoading(Math.floor(Math.random() * 1));
        }
        if (map.game == "GEARS4") {
           loadingText = getRandomGearsLoading(Math.floor(Math.random() * 3));
        }
        console.log(loadingText);
        return (
        <div className="loadingDiv">
          <p className="loadingText">
            {img} {loadingText}
            </p>
          </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
    }, dispatch);
}

function mapStateToProps(state) {
    return { currentUser: state.currentUser, map: state.map };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadingText);



// WEBPACK FOOTER //
// ./src/app/components/loading_text/index.jsx